/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable react/no-unescaped-entities */
/* eslint-disable no-restricted-imports */
import { useEffect, useState } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import { toast } from 'react-toastify';

import {
  Backdrop,
  Box,
  Button,
  Card,
  CardContent,
  Chip,
  CircularProgress,
  Divider,
  Grid,
  IconButton,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Typography,
} from '@material-ui/core';
import {
  Add as AddIcon,
  CheckCircle as CheckCircleIcon,
  Delete as DeleteIcon,
  Search as SearchIcon,
} from '@material-ui/icons';

import { Skeleton } from '@mui/material';
import { EmptyState, PageHeader, StockSearchAsync } from 'components/Contigo';
import { contigoService } from 'services';

import { useStyles } from './styles';

export default function FulfillOrder() {
  const classes = useStyles();
  const history = useHistory();
  const { orderId } = useParams();

  const [order, setOrder] = useState(null);
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);

  const [selectedItem, setSelectedItem] = useState(null);
  const [selectedStock, setSelectedStock] = useState(null); // Estoque selecionado no autocomplete

  const [stockQuantity, setStockQuantity] = useState(0);
  const [stockDetails, setStockDetails] = useState(null); // Detalhes do estoque (stock_id, location_id, location)
  const [loadingStock, setLoadingStock] = useState(false);

  const [selectedDeliveries, setSelectedDeliveries] = useState([]);

  useEffect(() => {
    loadOrder();
  }, [orderId]);

  useEffect(() => {
    if (selectedStock) {
      // Quando seleciona um novo estoque no autocomplete
      setStockQuantity(selectedStock.total_quantity);
      if (selectedStock.records && selectedStock.records.length > 0) {
        setStockDetails(selectedStock.records[0]);
      }
    }
  }, [selectedStock]);

  const loadOrder = async () => {
    try {
      setLoading(true);
      const response = await contigoService.getOrderById(orderId);
      setOrder(response.data);
    } catch (error) {
      console.error('Erro ao carregar pedido:', error);
      toast.error('Erro ao carregar pedido');
    } finally {
      setLoading(false);
    }
  };

  const handleSelectItem = async (item) => {
    setSelectedItem(item);
    setSelectedStock(null); // Reset do autocomplete
    setSelectedDeliveries([]);
    await loadStockQuantity(item.part_number);
  };

  const loadStockQuantity = async (partNumber) => {
    try {
      setLoadingStock(true);
      const response = await contigoService.listContigoStock({
        search: partNumber,
        skip: 0,
        take: 100, // Buscar todos os registros desse part number
      });

      const stockRecords = response.data || [];

      const total = stockRecords.reduce((sum, record) => sum + (record.quantity || 0), 0);
      setStockQuantity(total);

      if (stockRecords.length > 0) {
        setStockDetails(stockRecords[0]);
      } else {
        setStockDetails(null);
      }
    } catch (error) {
      console.error('Erro ao buscar estoque:', error);
      toast.error('Erro ao buscar estoque disponível');
      setStockQuantity(0);
      setStockDetails(null);
    } finally {
      setLoadingStock(false);
    }
  };

  const handleAddDelivery = () => {
    setSelectedDeliveries([...selectedDeliveries, { delivery: '', nf_entrada: '', quantity: 1 }]);
  };

  const handleRemoveDelivery = (index) => {
    setSelectedDeliveries(selectedDeliveries.filter((_, i) => i !== index));
  };

  const handleDeliveryChange = (index, field, value) => {
    const updated = [...selectedDeliveries];
    updated[index][field] = value;
    setSelectedDeliveries(updated);
  };

  const getTotalQuantity = () => {
    return selectedDeliveries.reduce((sum, d) => sum + (parseInt(d.quantity) || 0), 0);
  };

  const getRemainingQuantity = () => {
    if (!selectedItem) return 0;
    return selectedItem.quantity - (selectedItem.quantity_fulfilled || 0);
  };

  const canSubmit = () => {
    if (!selectedItem || selectedDeliveries.length === 0) return false;

    const allValid = selectedDeliveries.every((d) => {
      if (!d.delivery || !d.delivery.trim()) return false;
      if (!d.quantity || d.quantity <= 0) return false;
      return true;
    });

    const totalQty = getTotalQuantity();
    const remaining = getRemainingQuantity();

    return allValid && totalQty > 0 && totalQty <= remaining && totalQty <= stockQuantity;
  };

  const handleSubmit = async () => {
    if (!canSubmit()) return;

    if (!stockDetails) {
      toast.error('Detalhes do estoque não encontrados');
      return;
    }

    try {
      setSaving(true);

      const deliveries = selectedDeliveries.map((d) => {
        const deliveryData = {
          stock_id: stockDetails.id,
          delivery: d.delivery,
          nf_entrada: d.nf_entrada || undefined,
          quantity: parseInt(d.quantity),
          location_id: stockDetails.location_id,
          part_number: selectedItem.part_number,
        };

        // Se o part number foi alterado via autocomplete, incluir o novo part number
        if (selectedStock && selectedStock.part_number !== selectedItem.part_number) {
          deliveryData.new_part_number = selectedStock.part_number;
        }

        return deliveryData;
      });

      await contigoService.fulfillOrderItem(order.id, selectedItem.id, deliveries);

      toast.success('Item atendido com sucesso!');

      await loadOrder();

      setSelectedItem(null);
      setSelectedStock(null);
      setSelectedDeliveries([]);
      setStockQuantity(0);
      setStockDetails(null);
    } catch (error) {
      console.error('Erro ao atender item:', error);
      toast.error(error.response?.data?.message || 'Erro ao atender item');
    } finally {
      setSaving(false);
    }
  };

  const handleBack = () => {
    history.push(`/contigo/orders/${orderId}`);
  };

  if (loading) {
    return (
      <Box className={classes.container}>
        <Skeleton variant='text' width='40%' height={40} style={{ marginBottom: 8 }} />
        <Skeleton variant='text' width='25%' height={24} style={{ marginBottom: 24 }} />
        <Grid container spacing={3}>
          <Grid item xs={12} md={6}>
            <Card>
              <CardContent>
                <Skeleton variant='text' width='60%' height={32} />
                <Skeleton variant='rect' height={300} style={{ marginTop: 16 }} />
              </CardContent>
            </Card>
          </Grid>
          <Grid item xs={12} md={6}>
            <Card>
              <CardContent>
                <Skeleton variant='text' width='50%' height={32} />
                <Skeleton variant='rect' height={200} style={{ marginTop: 16 }} />
              </CardContent>
            </Card>
          </Grid>
        </Grid>
      </Box>
    );
  }

  if (!order) {
    return (
      <Box className={classes.container}>
        <EmptyState title='Pedido não encontrado' />
      </Box>
    );
  }

  const pendingItems =
    order.items?.filter((item) => (item.quantity_fulfilled || 0) < item.quantity) || [];

  return (
    <Box className={classes.container}>
      <PageHeader
        onBack={handleBack}
        title={`Atender Pedido ${order.order_number}`}
        subtitle={`Cliente: ${order.customer?.NOME || 'N/A'}`}
      />

      <Grid container spacing={3}>
        {/* Lista de Itens Pendentes */}
        <Grid item xs={12} md={6}>
          <Card>
            <CardContent>
              <Typography variant='h6' gutterBottom>
                Itens Pendentes de Atendimento
              </Typography>
              <Divider style={{ marginBottom: 16 }} />

              {pendingItems.length === 0 ? (
                <EmptyState
                  title='Todos os itens foram atendidos'
                  subtitle='Este pedido não possui itens pendentes'
                />
              ) : (
                <TableContainer>
                  <Table size='small'>
                    <TableHead>
                      <TableRow>
                        <TableCell>Part Number</TableCell>
                        <TableCell>Descrição</TableCell>
                        <TableCell align='center'>Pedido</TableCell>
                        <TableCell align='center'>Atendido</TableCell>
                        <TableCell align='center'>Pendente</TableCell>
                        <TableCell align='center'>Ação</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {pendingItems.map((item) => {
                        const fulfilled = item.quantity_fulfilled || 0;
                        const pending = item.quantity - fulfilled;

                        return (
                          <TableRow
                            key={item.id}
                            selected={selectedItem?.id === item.id}
                            hover
                            style={{ cursor: 'pointer' }}
                          >
                            <TableCell>{item.part_number}</TableCell>
                            <TableCell>{item.description || '-'}</TableCell>
                            <TableCell align='center'>
                              <Chip label={item.quantity} size='small' />
                            </TableCell>
                            <TableCell align='center'>
                              <Chip label={fulfilled} size='small' color='primary' />
                            </TableCell>
                            <TableCell align='center'>
                              <Chip label={pending} size='small' color='secondary' />
                            </TableCell>
                            <TableCell align='center'>
                              <Button
                                size='small'
                                variant='outlined'
                                color='primary'
                                startIcon={<SearchIcon />}
                                onClick={() => handleSelectItem(item)}
                                disabled={selectedItem?.id === item.id}
                              >
                                {selectedItem?.id === item.id ? 'Selecionado' : 'Selecionar'}
                              </Button>
                            </TableCell>
                          </TableRow>
                        );
                      })}
                    </TableBody>
                  </Table>
                </TableContainer>
              )}
            </CardContent>
          </Card>
        </Grid>

        {/* Formulário de Atendimento */}
        <Grid item xs={12} md={6}>
          {!selectedItem ? (
            <Card>
              <CardContent>
                <EmptyState
                  title='Selecione um item'
                  subtitle='Escolha um item da lista ao lado para iniciar o atendimento'
                />
              </CardContent>
            </Card>
          ) : (
            <Card>
              <CardContent>
                <Box display='flex' justifyContent='space-between' alignItems='center' mb={2}>
                  <Typography variant='h6'>Atender Item</Typography>
                  <Button
                    size='small'
                    onClick={() => {
                      setSelectedItem(null);
                      setSelectedStock(null);
                      setSelectedDeliveries([]);
                      setStockQuantity(0);
                      setStockDetails(null);
                    }}
                  >
                    Cancelar
                  </Button>
                </Box>

                <Box mb={3} p={2} bgcolor='#f5f5f5' borderRadius={1}>
                  <Grid container spacing={2}>
                    <Grid item xs={12}>
                      <Typography variant='body2' color='textSecondary' gutterBottom>
                        Part Number Original
                      </Typography>
                      <Typography variant='body1' style={{ fontWeight: 600, marginBottom: 16 }}>
                        {selectedItem.part_number}
                      </Typography>

                      <Box
                        p={2}
                        mb={2}
                        bgcolor='#E3F2FD'
                        borderRadius={1}
                        border='1px solid #90CAF9'
                      >
                        <Typography variant='body2' style={{ fontWeight: 500, marginBottom: 8 }}>
                          Editar Part Number (opcional)
                        </Typography>
                        <StockSearchAsync
                          value={selectedStock}
                          onChange={setSelectedStock}
                          label=''
                          placeholder='Busque outro part number no estoque para substituir...'
                        />
                        {selectedStock &&
                          selectedStock.part_number !== selectedItem.part_number && (
                            <Box mt={1} p={1} bgcolor='#FFF9C4' borderRadius={1}>
                              <Typography variant='caption' style={{ color: '#F57F17' }}>
                                ⚠️ Part number será alterado para{' '}
                                <strong>{selectedStock.part_number}</strong> e o anterior será
                                registrado no histórico
                              </Typography>
                            </Box>
                          )}
                      </Box>

                      {selectedItem.description && (
                        <>
                          <Typography
                            variant='body2'
                            color='textSecondary'
                            gutterBottom
                            style={{ marginTop: 8 }}
                          >
                            Descrição
                          </Typography>
                          <Typography variant='body1'>{selectedItem.description}</Typography>
                        </>
                      )}
                    </Grid>
                    <Grid item xs={6}>
                      <Typography variant='body2' color='textSecondary' gutterBottom>
                        Quantidade Pendente
                      </Typography>
                      <Typography variant='h6' color='secondary'>
                        {getRemainingQuantity()} unidades
                      </Typography>
                    </Grid>
                    <Grid item xs={6}>
                      <Typography variant='body2' color='textSecondary' gutterBottom>
                        Estoque Disponível
                      </Typography>
                      {loadingStock ? (
                        <Skeleton variant='text' width='60%' height={32} />
                      ) : (
                        <>
                          <Typography variant='h6' color='primary'>
                            {stockQuantity} unidades
                          </Typography>
                          {stockDetails && (
                            <Typography variant='caption' color='textSecondary'>
                              Local: {stockDetails.location}
                            </Typography>
                          )}
                        </>
                      )}
                    </Grid>
                  </Grid>
                </Box>

                <Divider style={{ margin: '16px 0' }} />

                <Box display='flex' justifyContent='space-between' alignItems='center' mb={2}>
                  <Typography variant='subtitle1'>Deliveries para Atendimento</Typography>
                  <Button
                    size='small'
                    variant='outlined'
                    color='primary'
                    startIcon={<AddIcon />}
                    onClick={handleAddDelivery}
                  >
                    Adicionar Delivery
                  </Button>
                </Box>

                {loadingStock ? (
                  <Box>
                    <Skeleton variant='text' width='50%' height={24} />
                    <Skeleton variant='rect' height={200} style={{ marginTop: 16 }} />
                    <Box mt={2}>
                      <Skeleton variant='text' width='70%' height={20} />
                      <Skeleton variant='text' width='60%' height={20} />
                    </Box>
                  </Box>
                ) : stockQuantity === 0 ? (
                  <Box p={2} bgcolor='#fff3cd' borderRadius={1}>
                    <Typography variant='body2' color='textSecondary'>
                      Sem estoque disponível para este part number.
                    </Typography>
                  </Box>
                ) : (
                  <>
                    {selectedDeliveries.length === 0 ? (
                      <Box p={2} bgcolor='#e3f2fd' borderRadius={1}>
                        <Typography variant='body2' color='textSecondary'>
                          Clique em "Adicionar Delivery" para começar.
                        </Typography>
                      </Box>
                    ) : (
                      <TableContainer component={Paper} variant='outlined'>
                        <Table size='small'>
                          <TableHead>
                            <TableRow>
                              <TableCell>Delivery *</TableCell>
                              <TableCell>NF Entrada</TableCell>
                              <TableCell align='center'>Quantidade *</TableCell>
                              <TableCell align='center'>Ação</TableCell>
                            </TableRow>
                          </TableHead>
                          <TableBody>
                            {selectedDeliveries.map((delivery, index) => (
                              <TableRow key={index}>
                                <TableCell>
                                  <TextField
                                    variant='outlined'
                                    size='small'
                                    placeholder='Digite a delivery'
                                    value={delivery.delivery}
                                    onChange={(e) =>
                                      handleDeliveryChange(index, 'delivery', e.target.value)
                                    }
                                    error={!delivery.delivery || !delivery.delivery.trim()}
                                    helperText={
                                      !delivery.delivery || !delivery.delivery.trim()
                                        ? 'Campo obrigatório'
                                        : ''
                                    }
                                    style={{ minWidth: 200 }}
                                  />
                                </TableCell>
                                <TableCell>
                                  <TextField
                                    variant='outlined'
                                    size='small'
                                    placeholder='Opcional'
                                    value={delivery.nf_entrada}
                                    onChange={(e) =>
                                      handleDeliveryChange(index, 'nf_entrada', e.target.value)
                                    }
                                    style={{ minWidth: 150 }}
                                  />
                                </TableCell>
                                <TableCell align='center'>
                                  <TextField
                                    type='number'
                                    variant='outlined'
                                    size='small'
                                    value={delivery.quantity}
                                    onChange={(e) =>
                                      handleDeliveryChange(
                                        index,
                                        'quantity',
                                        parseInt(e.target.value) || 0,
                                      )
                                    }
                                    inputProps={{ min: 1 }}
                                    error={delivery.quantity <= 0}
                                    style={{ width: 80 }}
                                  />
                                </TableCell>
                                <TableCell align='center'>
                                  <IconButton
                                    size='small'
                                    color='secondary'
                                    onClick={() => handleRemoveDelivery(index)}
                                  >
                                    <DeleteIcon fontSize='small' />
                                  </IconButton>
                                </TableCell>
                              </TableRow>
                            ))}
                          </TableBody>
                        </Table>
                      </TableContainer>
                    )}

                    {selectedDeliveries.length > 0 && (
                      <Box mt={2} p={2} bgcolor='#f5f5f5' borderRadius={1}>
                        <Grid container spacing={2}>
                          <Grid item xs={4}>
                            <Typography variant='body2' color='textSecondary'>
                              Total a Atender
                            </Typography>
                            <Typography variant='h6'>{getTotalQuantity()} unidades</Typography>
                          </Grid>
                          <Grid item xs={4}>
                            <Typography variant='body2' color='textSecondary'>
                              Estoque Disponível
                            </Typography>
                            <Typography
                              variant='h6'
                              color={getTotalQuantity() > stockQuantity ? 'error' : 'textPrimary'}
                            >
                              {stockQuantity} unidades
                            </Typography>
                          </Grid>
                          <Grid item xs={4}>
                            <Typography variant='body2' color='textSecondary'>
                              Quantidade Pendente
                            </Typography>
                            <Typography
                              variant='h6'
                              color={
                                getTotalQuantity() > getRemainingQuantity()
                                  ? 'error'
                                  : 'textPrimary'
                              }
                            >
                              {getRemainingQuantity()} unidades
                            </Typography>
                          </Grid>
                        </Grid>
                        {getTotalQuantity() > stockQuantity && (
                          <Box mt={1} p={1} bgcolor='#ffebee' borderRadius={1}>
                            <Typography variant='body2' color='error'>
                              A quantidade total excede o estoque disponível!
                            </Typography>
                          </Box>
                        )}
                        {getTotalQuantity() > getRemainingQuantity() && (
                          <Box mt={1} p={1} bgcolor='#ffebee' borderRadius={1}>
                            <Typography variant='body2' color='error'>
                              A quantidade total excede o pendente!
                            </Typography>
                          </Box>
                        )}
                      </Box>
                    )}
                  </>
                )}

                <Box mt={3} display='flex' gap={2}>
                  <Button
                    fullWidth
                    variant='contained'
                    color='primary'
                    size='large'
                    startIcon={<CheckCircleIcon />}
                    onClick={handleSubmit}
                    disabled={!canSubmit() || saving}
                  >
                    {saving ? 'Processando...' : 'Confirmar Atendimento'}
                  </Button>
                </Box>
              </CardContent>
            </Card>
          )}
        </Grid>
      </Grid>

      <Backdrop open={saving} style={{ zIndex: 9999, color: '#fff' }}>
        <CircularProgress color='inherit' />
      </Backdrop>
    </Box>
  );
}
